import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { SECURITY_PROFILE_PATH } from '../../../../config/paths';

const EditSecurityProfileButton = ({ securityProfileId }) => (
  <Link className="btn btn-primary" to={`${SECURITY_PROFILE_PATH}/${securityProfileId}/edit`}>
    Editar
  </Link>
);

EditSecurityProfileButton.propTypes = {
  securityProfileId: PropTypes.number.isRequired,
};

export default EditSecurityProfileButton;